import { SVGELEMENT } from '../../../../../enums/SVGELEMENT.js';
import SVGSHAPE from '../SVGSHAPE.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
// Model Structure
export const svgTSpanAttr = makeAttrStruct([
    ['x'],
    ['y'],
    ['fill'],
    ['stroke'],
    ['style']
]);
export const svgTSpanData = makeDataStruct([
    ['text', '']
]);
export const svgTSpanModel = makeStruct([
    ['attributes', svgTSpanAttr],
    ['data', svgTSpanData]
]);
// Simplified Model
export function svgTSpan(attributes, data) {
    return {
        attributes: attributes || svgTSpanAttr(),
        data: data || svgTSpanData()
    };
}
/** Creates a Line Shape for an SVG */
export default class SVGTSPAN extends SVGSHAPE {
    constructor(node, model) {
        super(node, SVGELEMENT.TSPAN, model);
        this.setInnerHTML(model.data.text);
    }
}
